<template>
  <v-app>
    <v-container class="max-width-container">
      <Header />
    </v-container>
    <div class="banner-home">
      <v-container class="max-width-container">
        <div class="text-title-banner"
          >Phần mềm quản lý dữ liệu và cung cấp dịch vụ bản đồ
        </div>
        <div
          class="mt-2"
          style="font-size: 16px; color: #e3fcf7; max-width: 570px"
          >Hệ thống triển khai các giao thức OGC tiêu chuẩn là Web Feature
          Service(WFS) và Web Map Service (WMS) cho người dùng
        </div>
        <div class="mt-6">
          <div
            class="button-header button-panel-header"
            @click="gotoDashboard"
            v-if="currentId"
            >Bảng điều khiển</div
          >
          <div
            class="button-header button-panel-header"
            @click="gotoLogin"
            v-else
            >Đăng nhập</div
          >
        </div>
      </v-container>
    </div>
    <v-container class="max-width-container mt-6 mb-4 pb-4">
      <div class="pt-6">
        <TinhNang />
      </div>

      <!-- <div style="text-align: center; margin-top: 80px" class="mb-6">
        <div style="color: #293340; font-weight: 700; font-size: 28px"
          >Dữ liệu bản đồ</div
        >
        <div style="color: #959aa9; font-size: 16px"
          >Các lớp bản đồ được công khai</div
        >
      </div> -->
      <!-- <v-card style="height: 600px; width: 100%">
        <Map />
      </v-card> -->
    </v-container>
    <Footer />
  </v-app>
</template>

<script>
import { mapGetters } from 'vuex'
import Footer from './footer.vue'
import Header from './header.vue'
import TinhNang from './tinhNang.vue'
export default {
  components: { Footer, Header, TinhNang },
  data() {
    return {
      show: false,
    }
  },
  computed: {
    ...mapGetters({
      currentId: 'auth/currentId',
      currentUser: 'auth/currentUser',
    }),
  },

  methods: {
    toggleNavbar() {
      this.show = !this.show
    },
    gotoLogin() {
      this.$router.push({
        name: 'login',
      })
    },
    gotoDashboard() {
      this.$router.push({
        name: 'home',
      })
    },
  },
}
</script>

<style scoped>
.text-title-banner {
  color: white;
  font-weight: 700;
  font-size: 28px;
  max-width: 530px;
  margin-top: 140px;
}
.max-width-container {
  max-width: 1300px;
}
.button-header {
  color: #263238;
  font-weight: 600;
  cursor: pointer;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 36px;
  max-width: 140px;
}
.button-panel-header {
  border-radius: 3px;
  background: #f2e205;
}
.button-header:hover {
  color: #2b713a;
}
.button-panel-header:hover {
  background: #c2d200;
  color: black;
}
.banner-home {
  width: 100%;
  background: #006751;
  background-repeat: no-repeat;
  height: 580px;
  background-position: right, center;
  background-size: 800px, 100% 100%;
  background-image: url('~@assets/images/imageBanner.svg'),
    url('~@assets/images/bannerHome.svg');
}

@media only screen and (max-width: 1200px) {
  .banner-home {
    background-image: none;
    background-image: url('~@assets/images/imageBanner.svg'),
      url('~@assets/images/bannerHome.svg');
    background-size: 400px, 100%;
  }
}
@media only screen and (max-width: 850px) {
  .banner-home {
    background-image: none;
    background-image: url('~@assets/images/bannerHome.svg');
    background-size: 100%;
  }
}
</style>
